'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isArray = exports.isArray = function isArray(array) {
  return Object.prototype.toString.call(array) === '[object Array]';
};

var isStringArray = exports.isStringArray = function isStringArray(array) {
  return !(!array || !isArray(array) || array.some(function (actionName) {
    return !actionName || typeof actionName !== 'string';
  }));
};

var isValidObject = exports.isValidObject = function isValidObject(obj) {
  return !(!obj || obj.constructor !== Object);
};